// extracted by mini-css-extract-plugin
export default {"copied-message":"button-copy-to-clipboard_copied-message__8LGz9","color-green":"button-copy-to-clipboard_color-green__QmTLg"};